import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 4L4 12M4 4L12 12", stroke: "#001A41", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClose;
